export type Honbu = '1honbu' | '2honbu';

export const HONBU_LABEL: Record<Honbu, string> = {
  '1honbu': '1本部',
  '2honbu': '2本部',
};

// 拠点の識別子。東京拠点は1本部・2本部の双方に存在し、稼働時間なども別々に設定するため、
// 本部を含めた値で一意にする。
export type BranchCode = '1honbu-tokyo' | '1honbu-osaka' | '2honbu-tokyo' | '2honbu-osaka';

// 設定の単位となる拠点。稼働時間・祝日/年末年始・架電の転送先は拠点単位で設定し、
// 配下には媒体・求人区分ごとの広告コードが複数ぶら下がる。
export interface Branch {
  code: BranchCode;
  label: string;
  // 東京拠点自身は転送元にならないため、転送先切替のトグルを表示しない
  canForwardToTokyo: boolean;
  // 仕事Noのくくりとなる広告コード（RPM 登録に用いる koukoku_code）
  advertisements: readonly string[];
}

interface JobNumberItemBase {
  id: string;
  jobNumber: string;
}

export interface EditingJobNumberItem extends JobNumberItemBase {
  status: 'editing';
}

export interface CommittedJobNumberItem extends JobNumberItemBase {
  status: 'committed';
}

export type JobNumberItem = EditingJobNumberItem | CommittedJobNumberItem;

export const WEEKDAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const;

export type Weekday = (typeof WEEKDAYS)[number];

export const WEEKDAY_LABEL: Record<Weekday, string> = {
  mon: '月',
  tue: '火',
  wed: '水',
  thu: '木',
  fri: '金',
  sat: '土',
  sun: '日',
};

export interface TimeRange {
  from: string | null;
  to: string | null;
}

export type Schedule = Record<Weekday, TimeRange>;

// 拠点単位の架電スケジュール。曜日別の時間帯に加え、祝日・年末年始(12/29〜1/3)に
// 架電するかどうかを保持する。祝日かどうかの判定はバックエンド側のカレンダーに委ねる。
export interface CallSchedule {
  weekdays: Schedule;
  callOnHoliday: boolean;
  callOnYearEnd: boolean;
}

export interface ScheduleState {
  current: CallSchedule;
  baseline: CallSchedule;
}
